export const loanPeriod = 12
export const interestRate = 2